export const assistConversationStorageKey = tenantId =>
  `directful-assist-conversation-${tenantId}`

export const NEW_CONVERSATION_WELCOME_MESSAGE =
  'Starting a new conversation. Pick a suggestion below or describe what you need.'

export const ASSIST_HELP_MESSAGE = `Here is what you can do:

- **help** — show this command list
- **reset** / **start over** / **new conversation** — start a fresh conversation
- **yes** / **confirm** — approve a pending action
- **no** / **decline** — decline a pending action
- **Ask something else** — exit a confirmation and choose a new topic
- Pick a **suggested topic** below to try a demo scenario
- Use **New chat** in the header to reset anytime`

const HELP_PATTERN = /^help$/i

const NEW_CONVERSATION_PATTERN =
  /^(new|new conversation|start over|start new|reset|cancel conversation)$/i

const CONFIRM_PATTERN = /^(yes|y|confirm|approve|ok|okay)$/i

const DECLINE_PATTERN = /^(no|n|decline|skip|not now)$/i

export const normalizeAssistPath = path => {
  const pathname = (path || '/').split('?')[0].split('#')[0]
  const normalized = pathname.replace(/\/+$/, '')
  return normalized || '/'
}

export const isSameAssistPath = (pathA, pathB) =>
  normalizeAssistPath(pathA) === normalizeAssistPath(pathB)

export const isHelpCommand = text => HELP_PATTERN.test((text || '').trim())

export const isNewConversationCommand = text =>
  NEW_CONVERSATION_PATTERN.test((text || '').trim())

export const isConfirmCommand = text => CONFIRM_PATTERN.test((text || '').trim())

export const isDeclineCommand = text => DECLINE_PATTERN.test((text || '').trim())

export const getAssistConversationStorageKeys = tenantIds =>
  [...new Set((tenantIds || []).filter(Boolean))].map(assistConversationStorageKey)

export const readAssistConversationId = tenantIds => {
  try {
    for (const key of getAssistConversationStorageKeys(tenantIds)) {
      const stored = sessionStorage.getItem(key)
      if (stored) {
        return stored
      }
    }
  } catch (e) {
    return null
  }
  return null
}

export const clearAssistConversationStorage = tenantIds => {
  try {
    getAssistConversationStorageKeys(tenantIds).forEach(key => {
      sessionStorage.removeItem(key)
    })
  } catch (e) {
    // sessionStorage unavailable
  }
}

export const persistAssistConversationId = (tenantIds, sessionId) => {
  if (!sessionId) {
    return
  }

  try {
    getAssistConversationStorageKeys(tenantIds).forEach(key => {
      sessionStorage.setItem(key, sessionId)
    })
  } catch (e) {
    // sessionStorage unavailable
  }
}

export const findTopicForDeepLink = (link, topics) => {
  if (!link || !topics?.length) {
    return null
  }

  if (link.message) {
    return { label: link.label, message: link.message }
  }

  const linkLabel = (link.label || '').toLowerCase()
  const exactMatch = topics.find(topic => topic.label.toLowerCase() === linkLabel)
  if (exactMatch) {
    return exactMatch
  }

  const partialMatch = topics.find(
    topic =>
      linkLabel.includes(topic.label.toLowerCase()) ||
      topic.label.toLowerCase().includes(linkLabel)
  )
  if (partialMatch) {
    return partialMatch
  }

  const getSignificantWords = text =>
    (text || '')
      .toLowerCase()
      .split(/[^a-z0-9]+/)
      .filter(word => word.length > 3)

  const linkWords = getSignificantWords(link.label)
  if (linkWords.length > 0) {
    const wordMatch = topics.find(topic => {
      const topicWords = getSignificantWords(topic.label)
      return linkWords.some(word => topicWords.includes(word))
    })
    if (wordMatch) {
      return wordMatch
    }
  }

  return null
}
